export default __webpack_public_path__ + "static/media/logo_white.31188c62.svg";